
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from './Casestudy.module.css';

const caseStudies = [
	{
		title: 'AI Prognoza',
		image: '/images/portfolio/ai prognoza.png',
		description:
			'AI Prognoza uses advanced AI to analyze business data and predict future trends. With real-time dashboards and customizable reports, it helps companies make smarter decisions, reduce risks, and seize new opportunities. Ideal for any industry looking to stay ahead in a fast-changing market.'
	},
	{
		title: 'AI Token Generation',
		image: '/images/portfolio/Ai-token-generation.png',
		description:
			'AI Token Generation offers a secure, automated way to create and manage digital tokens. Supporting multiple blockchains, it simplifies tokenization for businesses, ensuring compliance and security. Real-time analytics and easy integration make it perfect for digital asset management.'
	},
	{
		title: 'Construction Assistant',
		image: '/images/portfolio/construction-assistant.png',
		description:
			'Construction Assistant streamlines project management with AI-powered scheduling, resource tracking, and real-time updates. It connects teams on-site and in the office, predicts delays, and helps deliver projects on time and within budget. Designed for modern construction workflows.'
	},
	{
		title: 'Friction Translator',
		image: '/images/portfolio/fiction-translator.png',
		description:
			'Friction Translator uses AI to translate stories while preserving the author’s style and emotion. Supporting many languages, it helps writers and publishers reach global audiences. Customizable settings ensure each translation feels authentic and true to the original work.'
	},
	{
		title: 'VoiceBoostAI',
		image: '/images/portfolio/voiceboost.png',
		description:
			'VoiceBoostAI enhances audio clarity and removes background noise in real time using advanced AI. Perfect for podcasters, streamers, and professionals seeking studio-quality sound in any environment. Easy integration and intuitive controls for seamless audio improvement.'
	},
	// {
	// 	title: 'Revex App',
	// 	image: '/images/portfolio/revex-app.png',
	// 	description:
	// 		'Revex App is a review management platform that helps businesses collect, analyze, and respond to customer feedback. With automated alerts, analytics, and multi-platform support, it empowers brands to improve reputation and customer satisfaction efficiently.'
	// },
];


const Casestudy = () => {
	return (
		<section className={styles.casestudySection || 'casestudy-section'}>
			<div className={styles.container || 'container'}>
				<h2 className={styles.heading || 'casestudy-heading'}>Case Studies</h2>
				   <Swiper
					   modules={[Navigation, Pagination, Autoplay]}
					   navigation
					   pagination={{ clickable: true }}
					   autoplay={{ delay: 3500, disableOnInteraction: false }}
					   loop={true}
					   spaceBetween={40}
					   slidesPerView={1}
					   className={styles.swiper || 'casestudy-swiper'}
				   >
					{caseStudies.map((project, idx) => (
						<SwiperSlide key={idx}>
							<div className={styles.slideContent || 'casestudy-slide'}>
								<div className={styles.slideImage || 'casestudy-slide-image'}>
									<img src={project.image} alt={project.title} className={styles.image || 'casestudy-image'} />
								</div>
								<div className={styles.slideText || 'casestudy-slide-text'}>
									<h3 className={styles.title || 'casestudy-title'}>{project.title}</h3>
									<p className={styles.description || 'casestudy-description'}>{project.description}</p>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</section>
	);
};

export default Casestudy;
